import request from "@/global/request/request";
import API from "@/global/request/api";

const homeworkService = {
  plusIsCorrect() {
    return request.get(API.homeworkIsCorrect);
  },
  plusList(params = {}) {
    return request.get(API.homework, params);
  },
  plusShow(id) {
    return request.get(API.homeworkItem(id));
  },
  plusProjectInfo(id) {
    return request.get(API.homeworkProjectItem(id));
  },
  plusGrabOrder(id) {
    return request.post(API.homeworkItem(id));
  },
  plusCorrect(id, params = {}) {
    return request.put(API.homeworkItem(id), params);
  },
  plusNext(params = {}) {
    return request.put(API.homeworkNext, params);
  },
  getSources() {
    return request.get(API.homeworkSources);
  },
  projectIsCorrect() {
    return request.get(API.homeworkProjectV2IsCorrect);
  },
  projectList(params = {}) {
    return request.get(API.homeworkProjectV2, params);
  },
  projectShow(id) {
    return request.get(API.homeworkProjectV2Item(id));
  },
  projectGrabOrder(params = {}) {
    return request.put(API.homeworkProjectV2Grab, params);
  },
  projectCorrect(id, params = {}) {
    return request.put(API.homeworkProjectV2ItemCorrect(id), params);
  },
  releaseHomework(params) {
    return request.put(API.homeworkProjectV2Release, params);
  }
};

export default homeworkService;
